module.exports = __webpack_public_path__ + "static/media/new_application.c7a2031e.png";